import React from 'react';
import { useLang } from '@@Hooks/useLang';
import Icon from '@@Components/Icon/Icon';
import { ContactButton, LocationAddress, LocationContainer, LocationContactData, LocationContentTitle, LocationContactDataPhone } from '@@Components/OurLocationsRow/styled';
export const Location = (props) => {
    const { translate } = useLang();
    return React.createElement(LocationContainer, null,
        React.createElement(LocationContentTitle, null, props.title),
        React.createElement(LocationAddress, null, props.street),
        React.createElement(LocationContactData, { href: `mailto:${props.email}` }, props.email),
        React.createElement(LocationContactDataPhone, { href: `tel:${props.phone}` }, props.phone),
        React.createElement(ContactButton, null,
            React.createElement("a", { href: `/kontakt/${props.url_key}` },
                React.createElement("p", null, translate('navbar.contact')),
                React.createElement(Icon, { icon: "next", width: 15 }))));
};
